import React from 'react'
import "../assets/css/style.css";

function Onbordingimagecomponent({text}){



    return (
        <div className='main-div-oic'>
            <div>  <img
              src="/assets/images/Lightbulb.svg"
              alt="star"
              className="icon"
            /></div>
            <div className='Onbordingimagecomponent-text'>{text}</div>
        </div>
    )
}

export default Onbordingimagecomponent;